<script lang="ts">
  import { onMount } from "svelte";

  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { initDetail } from "./company.store";
import CompanyDetailPartActivities from "./CompanyDetailPartActivities.svelte";
import CompanyDetailPartAdditionalInfos from "./CompanyDetailPartAdditionalInfos.svelte";
  import CompanyDetailPartChannels from "./CompanyDetailPartChannels.svelte";
  import CompanyDetailPartContacts from "./CompanyDetailPartContacts.svelte";
  import CompanyDetailPartGeneral from "./CompanyDetailPartGeneral.svelte";
  import CompanyDetailPartInvoices from "./CompanyDetailPartInvoices.svelte";
  import CompanyDetailPartInvoicesEmails from "./CompanyDetailPartInvoicesEmails.svelte";
    import CompanyDetailPartInvoicesPayments from "./CompanyDetailPartInvoicesPayments.svelte";
  import CompanyDetailProjects from "./CompanyDetailProjects.svelte";

  enum CompanyPage {
    General = 1,
    AdditionalInfos,
    Channels,
    Contacts,
    Activities,
    Invoices,
    Emails,
    Payments,
    Projects
  }

  export let oid: number;

  let currentTab: CompanyPage = CompanyPage.General;
  let issupplier = window.location.pathname.indexOf("supplier") >= 0;

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == CompanyPage.General}
      on:click={(_) => {
        currentTab = CompanyPage.General;
      }}
    />
    {#if oid != 0}
      {#if !issupplier}
      <Tab
        label="Altre informazioni"
        active={currentTab == CompanyPage.AdditionalInfos}
        on:click={(_) => {
          currentTab = CompanyPage.AdditionalInfos;
        }}
      />
      {/if}
      <Tab
        label="Recapitis"
        active={currentTab == CompanyPage.Channels}
        on:click={(_) => {
          currentTab = CompanyPage.Channels;
        }}
      />
      <Tab
        label="Contatti"
        active={currentTab == CompanyPage.Contacts}
        on:click={(_) => {
          currentTab = CompanyPage.Contacts;
        }}
      />
      <Tab
        label="Task"
        active={currentTab == CompanyPage.Activities}
        on:click={(_) => {
          currentTab = CompanyPage.Activities;
        }}
      />
      <Tab
        label="Fatture"
        active={currentTab == CompanyPage.Invoices}
        on:click={(_) => {
          currentTab = CompanyPage.Invoices;
        }}
      />
      {#if !issupplier}
        <Tab
          label="Fatture inviate"
          active={currentTab == CompanyPage.Emails}
          on:click={(_) => {
            currentTab = CompanyPage.Emails;
          }}
        />
      {/if}
      {#if !issupplier}
        <Tab
          label="Insoluti e solleciti"
          active={currentTab == CompanyPage.Payments}
          on:click={(_) => {
            currentTab = CompanyPage.Payments;
          }}
        />
      {/if}
      <Tab
        label="Progetti"
        active={currentTab == CompanyPage.Projects}
        on:click={(_) => {
          currentTab = CompanyPage.Projects;
        }}
      />
  {/if}
  </Tabs>

  {#if currentTab == CompanyPage.General}
    <CompanyDetailPartGeneral {oid} />
  {/if}

  {#if currentTab == CompanyPage.AdditionalInfos}
    <CompanyDetailPartAdditionalInfos {oid} />
  {/if}

  {#if currentTab == CompanyPage.Channels}
    <CompanyDetailPartChannels />
  {/if}

  {#if currentTab == CompanyPage.Contacts}
    <CompanyDetailPartContacts />
  {/if}

  {#if currentTab == CompanyPage.Activities}
    <CompanyDetailPartActivities {oid}/>
  {/if}

  {#if currentTab == CompanyPage.Invoices}
    <CompanyDetailPartInvoices {oid} />
  {/if}

  {#if currentTab == CompanyPage.Emails}
    <CompanyDetailPartInvoicesEmails {oid} />
  {/if}

  {#if currentTab == CompanyPage.Payments}
    <CompanyDetailPartInvoicesPayments {oid} />
  {/if}

  {#if currentTab == CompanyPage.Projects}
    <CompanyDetailProjects {oid} />
  {/if}
</MainLayout>
